module.exports = __webpack_public_path__ + "static/media/icons.b8494223.svg";